import React from 'react';
import { Typography } from '@mui/material';
import DS_SocialLink from 'mui/components/elements/DS_SocialLink/DS_SocialLink';
import Link from '../../../../elements/Link';
import {
  StyledInfluencerLink,
  StyledSocialMenu,
  StyledSocialMenuHeader,
  StyledSocialMenuList,
  StyledSocialMenuListItem,
} from './styles';

const DS_FooterSocialMenu = ({ label, items, influencerLink }) => {
  return (
    <StyledSocialMenu>
      {label && <StyledSocialMenuHeader variant="DS_labelSmallBold">{label}</StyledSocialMenuHeader>}
      <StyledSocialMenuList>
        {items.map(({ id, type: { name }, socialIcon, url }) => (
          <StyledSocialMenuListItem key={id} data-test={`footer-social-icon-${name}`}>
            <DS_SocialLink type={name} socialIcon={socialIcon} url={url} rel="nofollow" />
          </StyledSocialMenuListItem>
        ))}
      </StyledSocialMenuList>
      {influencerLink && (
        <StyledInfluencerLink component={Link} variant="DS_labelSmallBold" url={influencerLink.url}>
          <Typography component="span" variant="DS_labelSmallBold">
            {influencerLink.title}
          </Typography>
        </StyledInfluencerLink>
      )}
    </StyledSocialMenu>
  );
};

export default DS_FooterSocialMenu;
